import client from '../lib/http-client';
// import { buildQuery } from '../lib/helper';

const endpoint = '/user-fee';

// eslint-disable-next-line import/prefer-default-export
export const getUserFeeConfig = (params, cb, errorCb) => {
	const url = `${endpoint}/service`;
	client
		.post(url, params)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};

export const getDetailUserFeeConfig = (userId, cb, errorCb) => {
	const url = `${endpoint}/user/${userId}`;
	client
		.get(url)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};

export const setConfig = (data, cb, errorCb) => {
	const url = `${endpoint}/set-config`;
	client
		.post(url, data)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};
